export const arrPopupWrong = [
  { text: 'Числовое значение каждого символа ты можешь найти в легенде.' },
]

export const arrPopupWrongСalculation = [
  { text: 'Вычисляй внимательнее.' },
]
export const arrPopup0 = [
  { text: 'Задание. Предугадай, понравится или нет определенный трек  другому пользователю', buttonTile: 'Продолжить' },
]

export const arrPopupWrongAction = [
  { text: 'Проверь ещё раз.' },
]
export const arrPopupActionYes = [
  { text: 'Согласен. Мне тоже кажется, что ему понравится!', buttonTitle: 'Продолжить' },
]
export const arrPopupActionNo = [
  { text: 'Согласен. Мне тоже кажется, что рекомендовать эту песню Толе не нужно.', buttonTitle: 'Продолжить' },
]

export const arrChooseNumber = [
  { text: 'отлично ты угадал все цифры', buttonTitle: 'Продолжить' },
]


export const arrAuthor = [
  { name: 'R&Bbit' },
  { name: 'Пати Р.' },
  { name: 'Чиа' },
  { name: 'Киса Кис' },
  { name: 'Дэни Стар' },
  { name: 'Кввоби' },
  { name: 'BassCow' },
]
